var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2521 6.52257L0.905114 11.9191C0.813388 11.9721 0.709327 12 0.603397 12C0.497466 12 0.3934 11.9721 0.301662 11.9192C0.209923 11.8662 0.133747 11.79 0.0807928 11.6983C0.0278389 11.6065 -2.58371e-05 11.5025 1.79764e-08 11.3965V0.603475C-2.58371e-05 0.497544 0.0278389 0.393474 0.0807928 0.301729C0.133747 0.209983 0.209923 0.133797 0.301662 0.0808314C0.3934 0.0278657 0.497466 -1.22584e-05 0.603397 4.04356e-09C0.709327 1.22664e-05 0.813388 0.0279149 0.905114 0.0809018L10.2521 5.47743C10.3439 5.53037 10.4201 5.60654 10.4731 5.69827C10.526 5.79 10.5539 5.89407 10.5539 6C10.5539 6.10593 10.526 6.21 10.4731 6.30173C10.4201 6.39346 10.3439 6.46963 10.2521 6.52257Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.8755dd9face8166bcab6f31d8fbd0298.svg";
export { ForwardRef as ReactComponent };